<template lang="">
    <div class="contents">
        <div class="customer_wrap">
            <div class="cs_card">
                <div class="box">
                    <img src="../../assets/images/common/ico_cs.png" alt="고객센터 이용안내">
                    <p>고객센터 이용안내</p>
                    <h5>070.4233.0655</h5>
                    <span>FAX : 02)478-5822</span>
                </div>
                <p>운영시간</p>
                <span>월-금 09:00~17:30</span>
            </div>
            <div class="cs_tab">
                <CustomerServiceNavigation/>
                <div class="cs_tabPanel active" id="cs_tab02">
                    <h5 class="title">자주묻는질문(FAQ)</h5>
                    <div class="faq_wrap">
                        <span class="search_box">
                            <input type="text" placeholder="질문을 입력해주세요." v-model="searchInput">
                            <button type="button" @click="getSearch">검색버튼</button>
                        </span>
                        <p class="text">총 <span>{{ faqCount }}</span>개의 FAQ가 있습니다.</p>
                        <ul class="faq_list">
                            <li
                                v-for="(faq, index) in faqList"
                                class="faq"
                                :class="{active: isFaqOpen(index)}"
                                @click="toggleFaq(index)"
                            >
                                <div class="faq_question">
                                    <h3 class="faq_title">
                                        {{ faq.title }}
                                    </h3>
                                </div>
                                <div class="faq_answer">
                                    <p class="faq_text">
                                        {{ faq.content }}
                                    </p>
                                    <div class="faq_file">
                                        <!-- <p><i class="ico_file"></i> 첨부파일1.jpg</p> -->
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <CustomerServicePagination
                            :totalPages = "totalPages()"
                            :currentPage = currentPage
                            @changePage = "changePage"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CustomerServiceNavigation from '@/views/customerService/layout/CustomerServiceNavigation.vue';
import CustomerServicePagination from '../common/CustomerServicePagination.vue';
import { mapActions, mapState } from 'vuex';

const faqModule = 'faqModule'

export default {
    components: {
        CustomerServiceNavigation,
        CustomerServicePagination
    },

    data () {
        return {
            currentPage: 1,
            searchWord: '',
            searchInput: '',
            searchType: '',
            openFaqs: []
        }
    },

    methods: {
        ...mapActions(faqModule, [
            'requestFaqList'
        ]),

        totalPages () {
            return Math.ceil(this.faqCount / 10);
        },

        async changePage (page) {
            this.currentPage = page
            const {currentPage, searchWord} = this
            this.openFaqs = []
            await this.requestFaqList({currentPage, searchWord})
        },

        async getSearch(){ 
            this.searchType = 'all'
            this.searchWord = this.searchInput
            this.currentPage = 1
            this.openFaqs = []
            const {currentPage, searchType, searchWord} = this
            await this.requestFaqList({currentPage, searchType, searchWord})
        },

        toggleFaq(idx) {
            const index = this.openFaqs.indexOf(idx);
            if (index !== -1) {
                this.openFaqs.splice(index, 1);
            } else {
                this.openFaqs.push(idx);
            }
        }
    },

    computed: {
        ...mapState(faqModule, [
            'faqList',
            'faqCount'
        ]),

        isFaqOpen() {
            return (idx) => this.openFaqs.includes(idx);
        }
    },

    async mounted() {
        const {currentPage, searchType, searchWord} = this
        await this.requestFaqList({currentPage, searchType, searchWord})
    }

}
</script>
<style lang="">

</style>